import React from 'react'
import PopupBottomModal from '../../../../components/popup-bottom-modal'

import './index.less'

interface Props {
  visible: boolean
  onClose: () => void
  shareTimes: number
  title?: string
  imgUrl: string
  onShare: () => void
}

const SharingCumulativeModal = (props: Props) => {
  const {
    visible,
    onClose,
    shareTimes,
    title = '',
    imgUrl,
    onShare
  } = props

  const getShareInfo = () => {
    if (!shareTimes) return { overPercent: 0, shareContent: '' }

    let overPercent = 0

    if (shareTimes >= 10 && shareTimes < 30) {
      overPercent = 80
    } else if (shareTimes >= 30 && shareTimes < 50) {
      overPercent = 90
    } else if (shareTimes >= 50 && shareTimes < 100) {
      overPercent = 95
    } else {
      overPercent = 99
    }

    return {
      overPercent,
      shareContent: `恭喜你达成${shareTimes}次贡献里程碑，你已经成功超过了${overPercent}%的人，继续努力！`
    }
  }

  return (
    <PopupBottomModal
      visible={visible}
      onClose={onClose}
      title={title || `累计共享${shareTimes}次`}
    >
      <div className='sharing-cumulative-modal-wrap'>
        <img alt='' className='image' src={imgUrl} />
        <div className='cover-text'>
          <div className='title'>恭喜达成共享里程碑！{'\n'}{'\n'}</div>
          <div className='sub-title'>
            你已经成功超过<span className='percent'> {getShareInfo().overPercent}% </span>的人，{'\n'}继续努力！
          </div>
        </div>
        <div className='desc'>{getShareInfo().shareContent}</div>
        <div className='button' onClick={onShare}>点击分享，收获更多</div>
      </div>
    </PopupBottomModal>
  )
}

export default SharingCumulativeModal